export default __webpack_public_path__ + "static/media/benefit_3.b057d226.png";